<template>
    <div>
        <van-swipe v-if="items.length" class="my-swipe" :autoplay="3000" indicator-color="white">
            <van-swipe-item v-for="item in items" :key="item.id" @click="url(item.url)">
                <img :src="item.image" :alt="item.title" />
            </van-swipe-item>
        </van-swipe>
    </div>
</template>
<script>
    import { Swipe, SwipeItem } from 'vant';
    export default {
		props: {
			items: {
				type: Array,
				default: () => []
			}
		},
        methods:{
            url(path) {
                if (path.indexOf("http") != -1) {
                    window.location.href = path;
                } else {
                    if (path == this.$store.getters.unionid) {
                        this.$router.back();
                    } else {
                        this.$router.push(path);
                    }
                }
            },
        }
    }
</script>
<style>
    .my-swipe{
        width: calc(100% - 40px);
        border-radius: 20px;
        margin: 20px auto;
        height: 120px;
    }
    .my-swipe img{
        width: 100%;
        height: 120px;
    }
</style>
